const { InnerBlocks } = wp.blockEditor;
import Inspector from './inspector';

export default ({ attributes, setAttributes }) => {
  const { margin, position } = attributes;

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div className={`GridButtons ${margin} ${position}`}>
        <InnerBlocks
          template={[['base/button-sumicity']]}
          allowedBlocks={['base/button-sumicity']}
        />
      </div>
    </>
  );
};
